import { gql } from '@apollo/client'

const SIMPLE_CHALLENGE_FRAGMENT = gql`
  fragment SimpleChallengeFragment on Challenge {
    id
    name
    position
  }
`

export default SIMPLE_CHALLENGE_FRAGMENT
